//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'magic_nav_auto',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};